import styled from 'styled-components'
import Drawer from 'antd/lib/drawer'
import Icon from 'antd/lib/icon'

export const DesktopSlot = styled.div`
  margin-top: 16px;
  @media (max-width: 1099px) {
    display: none;
  }
`

export const MobileSlot = styled.div`
  display: none;
  @media (max-width: 1099px) {
    display: block;
    margin-bottom: var(--spacing-16);
  }
`

export const Trigger = styled.button`
  appearance: none;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: var(--neutral-white);
  border: 1px solid var(--neutral-border-med);
  cursor: pointer;
  text-align: left;
  font: inherit;
  #chevron {
    width: 8px;
    height: 13px;
    transition: transform .2s ease;
  }

  &:hover {
    border-color: var(--neutral-body);
    #chevron {
      transform: translateX(4px);
    }
  }
`

export const TriggerMain = styled.span`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;

  .tapeBadge {
    width: 36px;
    height: 36px;
  }

  #triggerTitle {
    font: 600 16px/22px var(--font-barlow);
    letter-spacing: -0.1px;
    color: var(--accent-green);
  }

  .trigger-copy {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .trigger-subtitle {
    font: 400 12px/18px var(--font-inter);
    color: var(--neutral-darkest);
  }
`

export const SizeRecDrawer = styled(Drawer)`
  z-index: 90;
  .ant-drawer-body {
    padding: 0;
  }

  .ant-drawer-title {
    margin-right: 40px;
  }
  &.size-recs-desktop.ant-drawer-right {
    pointer-events: none;
    &.ant-drawer-open {
      pointer-events: auto;
    }
    .ant-drawer-content-wrapper {
      pointer-events: auto;
      position: fixed;
      top: 102px;
      right: 0;
      bottom: 0;
      left: auto;
      height: auto !important;
      max-height: none;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
    .ant-drawer-content,
    .ant-drawer-wrapper-body,
    .ant-drawer-body {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      height: 100% !important;
      max-height: none;
      min-height: 0;
    }
    .ant-drawer-body {
      overflow: hidden;
    }
  }
`

export const HeaderTitle = styled.h2`
  margin: 0;
  font: 600 24px/30px var(--font-barlow-semi-condensed);
  letter-spacing: 0.4px;
  color: var(--neutral-darkest);

  @media (max-width: 1279px) {
    font: 600 20px/26px var(--font-barlow-semi-condensed);
    letter-spacing: 0.6px;
  }
`

export const HeaderIdentity = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  .tapeBadge {
    width: 36px;
    height: 36px;
  }
`

export const MobileSheet = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow: hidden;
  #mobileTop {
    flex: 0 0 auto;
    width: 100%;
  }
`

export const Grabber = styled.div`
  width: 36px;
  height: 4px;
  border-radius: var(--radius-full);
  background: var(--neutral-muted);
  margin: 0 auto;
  margin-top: 8px;
`

export const MobileHeader = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-12);
  width: 100%;
  padding: var(--spacing-16);
  border-bottom: 1px solid var(--neutral-border-light);
`

export const CloseButton = styled(Icon)`
  padding: 10px;
  border: 1px solid var(--neutral-border-med);
  font-size: 18px;
  color: var(--neutral-darkest);
`

export const DrawerBody = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;

  .size-recs-mobile & {
    max-height: calc(80vh - 85px);
  }
`

export const RecList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`

export const ColumnHead = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.75fr) minmax(0, 1.1fr) minmax(0, 1.3fr);
  column-gap: 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--neutral-border-light);
  font: 600 12px/20px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #4a4a48;
`

export const RecRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.75fr) minmax(0, 1.1fr) minmax(0, 1.3fr);
  column-gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid var(--neutral-border-light);
`

export const ProductBlock = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`

export const ForName = styled.div`
  min-width: 0;
  font: italic 400 12px/18px var(--font-inter);
  color: var(--neutral-muted);
`

export const NameLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
`

export const ProductName = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font: 600 16px/20px var(--font-barlow);
  color: var(--neutral-darkest);
  span {
    font: 400 14px/20px var(--font-inter);
    color: var(--neutral-muted);
    margin-left: var(--spacing-6);
  }
`

export const Value = styled.div`
  font: 400 14px/22px var(--font-inter);
  color: var(--neutral-dark-gray);
`

export const FitButton = styled.button`
  width: 16px;
  height: 16px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: var(--neutral-border-med);
  color: #4a4a48;
  font: 700 10px/16px var(--font-barlow);
  cursor: pointer;
  flex-shrink: 0;
`

export const FitTip = styled.div`
  color: var(--neutral-darkest);
  font: 400 12px/18px var(--font-inter);
  .fitTitle {
    background: var(--neutral-border-light);
    margin: -6px -8px 0;
    border-radius: 5px 5px 0 0;
    padding: 4px 8px;
  }
  .fit {
    font-weight: 600;
    margin-top: 4px;
    font-style: italic;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ShoppingCartPageV2/CartSizeRecs/styledComponents.tsx